import React from 'react';
import Chart from 'chart.js';

export default class ChartCosts extends React.Component {
	constructor(props) {
		super(props);
		this.chart = null

	}
	componentDidMount () {
		var ctx = document.getElementById("chart-costs");
		var data = {
			    labels: [
			        "Kosten: KFZs inkl. Kraftst.",
			        "Kosten: ÖV",
			        "Wohnkosten"
			    ],
			    datasets: [
			        {
			            data: [this.props.costs[0], this.props.costs[1], this.props.costs[2]],
			            backgroundColor: [
			                "#d8d4a6",
			                "#dff0d8",
			                "#e0e0e0"
			            ],
			            hoverBackgroundColor: [
			            	"#d8d4a6",
			                "#dff0d8",
			                "#e0e0e0"
			            ]
			        }]
			};
		
		this.chart = new Chart(ctx,{
		    type: 'pie',
		    data: data
		});
	}
	componentDidUpdate() {
		var ctx = document.getElementById("chart-costs");
		var data = {
			    labels: [
			        "Kosten: KFZs inkl. Kraftst.",
			        "Kosten: ÖV",
			        "Wohnkosten"
			    ],
			    datasets: [
			        {
			            data: [this.props.costs[0], this.props.costs[1], this.props.costs[2]],
			            backgroundColor: [
			                "#d8d4a6",
			                "#dff0d8",
			                "#e0e0e0"
			            ],
			            hoverBackgroundColor: [
			            	"#d8d4a6",
			                "#dff0d8",
			                "#e0e0e0"
			            ]
			        }]
			};
		
		this.chart.destroy()
		this.chart = new Chart(ctx,{
		    type: 'pie',
		    data: data
		});
	}
	
	render () {
	return (	
		<div>
		<canvas id="chart-costs">
		</canvas>
		<hr></hr>
		<p>Gesamtkosten: {this.props.costs[0] + this.props.costs[1] + this.props.costs[2] + ' € p. M.'}</p>
		</div>
	)
	}
}


// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/dailytrips/costs_chart.js